import React from "react";

const Milestones = () => {
  return <div>Milestones</div>;
};

export default Milestones;
